import request from 'superagent';
import ApplicationConst from "../ApplicationConst";


const ajaxState = {
    START:"START",
    FINISH: "FINISH",
    ERROR: "ERROR"
};

const ajaxBehaviour = (context, state) => {
    switch(state){
        case ajaxState.START:
            break;
        case ajaxState.FINISH:
            break;
        case ajaxState.ERROR:
            break;
    }
};

const ajax = store => next => action => {
    next(action);
    if(action.type === ApplicationConst.AJAX_CALL){
        console.log("AJAX CALL");
        switch (action.entity.getMethod()) {
            case "POST":
                request
                    .post(action.entity.getUrl())
                    .set('Content-Type', 'application/json')
                    .set('SHA-Token-Policy', store.getState().application.location.token)
                    .withCredentials()
                    .send(action.payload)
                    .end((error, res) => {
                        if(error) {
                            return next ({
                                type: ApplicationConst.AJAX_ERROR,
                                payload:error
                            });
                        }
                        const data = JSON.parse(res.text);
                        next({
                            type:action.entity.getContext(),
                            payload:data
                        });
                        if(action.hasOwnProperty("context") && action.hasOwnProperty("contextId"))
                            if(action.contextId !== null && action.context !== null) {
                                let cb = action.entity.getCallback();
                                store.dispatch(cb(action.context, action.contextId));
                            }
                    });
                break;
            case "PUT":
                request
                    .put(action.entity.getUrl())
                    .set('Content-Type', 'application/json')
                    .set('SHA-Token-Policy', store.application.location.token)
                    .withCredentials()
                    .send(action.payload)
                    .end((error, res) => {
                        if(error) {
                            return next ({
                                type: ApplicationConst.AJAX_ERROR,
                                payload:error
                            });
                        }
                        const data = JSON.parse(res.text);
                        next({
                            type:action.entity.getContext(),
                            payload:data
                        });
                        if(action.hasOwnProperty("context") && action.hasOwnProperty("contextId"))
                            if(action.contextId !== null && action.context !== null) {
                                let cb = action.entity.getCallback();
                                store.dispatch(cb(action.context, action.contextId));
                            }
                    });
                break;
            case "GET":
                store.dispatch({type:action.entity.getContext() + "_START"});
                console.log("GET METHOD");
                request
                    .get(action.entity.getUrl())
                    .withCredentials()
                    .set('Content-Type', 'application/json')
                    .set('SHA-Token-Policy', store.getState().application.location.token)
                    .send()
                    .end((error, res) => {
                        if(error) {
                          console.log("AJAX ERROR: " + error);
                            return next({
                                type: ApplicationConst.AJAX_ERROR,
                                payload: error
                            });
                        }
                        const data = JSON.parse(res.text);
                        next({
                            type:action.entity.getContext(),
                            payload: data
                        });
                        console.log(data);
                        store.dispatch({type:action.entity.getContext() + "_FINISHED"});
                    });
                break;
            case "DELETE":
                request
                    .delete(action.entity.getUrl())
                    .withCredentials()
                    .set('SHA-Token-Policy', store.application.location.token)
                    .send()
                    .end((error, res) => {
                        if(error) {
                            return next({
                                type: ApplicationConst.AJAX_ERROR,
                                payload: error
                            });
                        }
                        const data = JSON.parse(res.text);
                        next({
                            type:action.entity.getContext(),
                            payload: data
                        });
                        if(action.hasOwnProperty("contextId") && action.hasOwnProperty("context"))
                            if(action.contextId !== null && action.contextId !== null){
                                let cb = action.entity.getCallback();
                                store.dispatch(cb(action.context, action.contextId));
                            }
                    });
                break;
            default:
                break;
        }
    }
};

export default ajax;



// WEBPACK FOOTER //
// ./src/api/ajax.js